export type CapabilityDiffProps = {
  role: string;
  defaults: string[];
  override?: string[];
};

export function diffCaps(
  defaultCaps: string[],
  overrideCaps: string[] | undefined,
): { added: string[]; removed: string[]; same: string[] } {
  if (!overrideCaps) return { added: [], removed: [], same: [...defaultCaps].sort() };
  const d = new Set(defaultCaps);
  const o = new Set(overrideCaps);
  return {
    added: [...o].filter((c) => !d.has(c)).sort(),
    removed: [...d].filter((c) => !o.has(c)).sort(),
    same: [...o].filter((c) => d.has(c)).sort(),
  };
}

export function CapabilityDiff({ role, defaults, override }: CapabilityDiffProps) {
  const { added, removed } = diffCaps(defaults, override);
  if (!override || (added.length === 0 && removed.length === 0)) return null;
  return (
    <div
      className="flex flex-col gap-sp-1 rounded-r-default border border-gray-300 bg-gray-50 px-sp-3 py-sp-2"
      data-role={role}
      data-testid={`diff-${role}`}
    >
      <p className="text-fs-eyebrow font-medium uppercase tracking-[0.14em] text-gray-700">
        {role}
      </p>
      <ul className="flex flex-wrap gap-sp-2 font-mono text-fs-meta">
        {added.map((c) => (
          <li key={`+${c}`} className="text-healthy-fg" aria-label={`added ${c}`}>
            + {c}
          </li>
        ))}
        {removed.map((c) => (
          <li key={`-${c}`} className="text-critical" aria-label={`removed ${c}`}>
            − {c}
          </li>
        ))}
      </ul>
    </div>
  );
}
